// extracted by mini-css-extract-plugin
module.exports = {"textLink":"style_textLink__3KZhv"};